document.addEventListener('DOMContentLoaded', function() {
  const decorationServiceVariantIds = [56639019843924,56896939917652,56896939950420,56896939983188,56896940015956,56896940048724];
  const isDecorationService = function(id) { return decorationServiceVariantIds.includes(Number(id)); };
  const menuButton = document.querySelector('[data-lmu-menu-toggle]');
  const navigation = document.querySelector('[data-lmu-nav]');
  const menuLabel = document.querySelector('[data-menu-label]');

  if (menuButton && navigation) {
    menuButton.addEventListener('click', function() {
      const isOpen = navigation.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
      if (menuLabel) menuLabel.textContent = isOpen ? 'Close menu' : 'Open menu';
    });
  }

  document.querySelectorAll('.lmu-submenu-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const submenu = toggle.nextElementSibling;
      const isOpen = submenu && submenu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(Boolean(isOpen)));
    });
  });

  document.querySelectorAll('a[href="/pages/embroidery-printing"]').forEach(function(link) {
    link.href = '/pages/embroidery-print';
  });

  const drawer = document.querySelector('[data-cart-drawer]');
  const money = function(pence) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format((Number(pence) || 0) / 100);
  };
  const escapeHtml = function(value) {
    return String(value == null ? '' : value).replace(/[&<>'\"]/g, function(character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '\"': '&quot;' }[character];
    });
  };

  async function changeCart(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    if (window.LMUBranding) await window.LMUBranding.sync();
    await refreshCart(true);
  }

  async function refreshCart(showMessage) {
    if (!drawer) return;
    const cart = await fetch('/cart.js').then(function(response) { return response.json(); });
    const visibleItems = cart.items.filter(function(item) { return !isDecorationService(item.variant_id); });
    const decoratedQuantity = visibleItems.reduce(function(total,item){ const d=item.properties&&item.properties.Decoration; return d&&d!=='No decoration'?total+item.quantity:total; },0);
    const tier = decoratedQuantity && window.LMUBranding ? window.LMUBranding.tierFor(decoratedQuantity) : null;
    const decorationUnit = tier ? Math.round(tier.net * 100) : 0;
    const decorationTotal = decorationUnit * decoratedQuantity;
    const garmentTotal = visibleItems.reduce(function(total, item) { return total + item.final_line_price; }, 0);

    document.querySelectorAll('[data-cart-count]').forEach(function(element) {
      element.textContent = visibleItems.reduce(function(total, item) { return total + item.quantity; }, 0);
    });

    const itemsContainer = drawer.querySelector('[data-cart-items]');
    itemsContainer.innerHTML = visibleItems.length ? visibleItems.map(function(item) {
      const properties = item.properties || {};
      const decoration = properties.Decoration || 'No decoration';
      const isDecorated = decoration !== 'No decoration';
      const logo = properties['Logo file'] || '';
      const logoMarkup = logo ? '<a class="lmu-cart-line__logo" href="' + escapeHtml(logo) + '" target="_blank"><img src="' + escapeHtml(logo) + '" alt="Uploaded logo"><span>Uploaded logo</span></a>' : '';
      const brandingMarkup = isDecorated ? '<div class="lmu-cart-line__branding"><b>' + escapeHtml(decoration) + ' · ' + money(decorationUnit) + ' each ex VAT (' + money(decorationUnit * 1.2) + ' inc VAT)</b><span>' + escapeHtml(properties['Logo position'] || '') + '</span>' + logoMarkup + '</div>' : '';
      const imageMarkup = item.image ? '<img class="lmu-cart-line__image" src="' + escapeHtml(item.image) + '&width=180" alt="">' : '';
      const priceMarkup = '<b>' + money(item.final_line_price) + '</b><small>Garments</small>';
      return '<article class="lmu-cart-line"><div class="lmu-cart-line__media">' + imageMarkup + '</div><div class="lmu-cart-line__content"><strong>' + escapeHtml(item.product_title) + '</strong><span>' + escapeHtml(item.variant_title || '') + '</span>' + brandingMarkup + '<div class="lmu-cart-line__controls"><button type="button" data-cart-minus data-key="' + escapeHtml(item.key) + '" data-qty="' + item.quantity + '">−</button><span>' + item.quantity + '</span><button type="button" data-cart-plus data-key="' + escapeHtml(item.key) + '" data-qty="' + item.quantity + '">+</button><button type="button" class="lmu-cart-line__remove" data-cart-remove data-key="' + escapeHtml(item.key) + '">Remove</button></div></div><div class="lmu-cart-line__price">' + priceMarkup + '</div></article>';
    }).join('') : '<div class="lmu-cart-empty"><strong>Your basket is empty</strong><p>Add garments to start your order.</p></div>';

    drawer.querySelector('[data-cart-total]').textContent = money(garmentTotal + decorationTotal);
    let breakdown = drawer.querySelector('[data-cart-breakdown]');
    if (!breakdown) {
      breakdown = document.createElement('div');
      breakdown.className = 'lmu-cart-breakdown';
      breakdown.dataset.cartBreakdown = '';
      drawer.querySelector('.lmu-cart-drawer__footer').prepend(breakdown);
    }
    breakdown.innerHTML = '<div><span>Garments</span><strong>' + money(garmentTotal) + '</strong></div>' +
      '<div><span>Decoration</span><strong>' + money(decorationTotal) + '</strong></div>' +
      '<div class="lmu-cart-breakdown__total"><span>Subtotal ex VAT</span><strong>' + money(garmentTotal + decorationTotal) + '</strong></div>';

    drawer.querySelectorAll('[data-cart-minus]').forEach(function(button) {
      button.onclick = function() { changeCart(button.dataset.key, Math.max(0, Number(button.dataset.qty) - 1)); };
    });
    drawer.querySelectorAll('[data-cart-plus]').forEach(function(button) {
      button.onclick = function() { changeCart(button.dataset.key, Number(button.dataset.qty) + 1); };
    });
    drawer.querySelectorAll('[data-cart-remove]').forEach(function(button) {
      button.onclick = function() { changeCart(button.dataset.key, 0); };
    });

    const message = drawer.querySelector('[data-cart-message]');
    if (showMessage && message) {
      message.hidden = false;
      setTimeout(function() { message.hidden = true; }, 1800);
    }
  }

  function openCart(showMessage) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lmu-cart-open');
    refreshCart(Boolean(showMessage));
  }
  function closeCart() {
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('lmu-cart-open');
  }

  document.querySelectorAll('[data-cart-open]').forEach(function(button) {
    button.addEventListener('click', function(event) { event.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function(button) { button.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function(event) { if (event.key === 'Escape') closeCart(); });
  window.LMUCart = { open: openCart, refresh: refreshCart };
  refreshCart();
});
